import Image from 'next/image'
import React from 'react'

import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/legacy-src/components/ui/dropdown-menu'
import { locales } from '@/legacy-src/constants/locale.constants'
import { cn } from '@/legacy-src/lib/utils'
import { getLocaleDisplayName, getLocaleDomain } from '@/legacy-src/utilities/languagesConfig'

import { ButtonIcon } from '@/src/domains/design-system/components/Button'

import Icon from '../icons/Icon'
import { type LanguagePickerProps } from './LanguagePicker'

type ImageForLanguageProps = {
  language: {
    text: string
    domain: string
  }
}

export const ImageForLanguage: React.FC<ImageForLanguageProps> = ({ language }) => {
  return (
    <Image
      key={language.text}
      src={`/images/flags/flag.${language.domain}.svg`}
      alt={language.text}
      width={22}
      height={22}
      priority
      className="mr-4"
    />
  )
}

const LanguagePickerDropdown: React.FC<LanguagePickerProps & { children: React.ReactNode }> = ({
  align,
  className,
  children,
  theme,
}) => {
  const languagesList = locales
  const isDarkTheme = theme === 'dark'

  return (
    <div className={cn('relative', className)}>
      <div className="hidden">
        {/* the flag images are here so they are preloaded, since the dropdown is not in dom yet */}
        {languagesList.map((locale) => {
          const text = getLocaleDisplayName(locale)
          const domain = getLocaleDomain(locale) || 'com'
          return <ImageForLanguage key={`lang-${locale}`} language={{ text, domain }} />
        })}
      </div>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <ButtonIcon variant={isDarkTheme ? 'alternative' : 'outline'} size="small">
            <Icon icon="internet" color={isDarkTheme ? 'primary' : undefined} />
          </ButtonIcon>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="rounded-xl bg-white py-2 shadow-rebrand" align={align}>
          {children}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

export default LanguagePickerDropdown
